import { useEffect, useState } from 'react';
import HomePage from './pages/HomePage';
import { homeAliasPath, homePath, matchHomePath } from './utils/home-path';

export const homeRoute = {
  name: 'home',
  path: homePath,
  exact: true,
  component: HomePage
};

export const homeAliasRoute = {
  name: 'home',
  path: homeAliasPath,
  exact: true,
  component: HomePage
};

const readLocation = () => ({
  pathname: window.location.pathname,
  search: window.location.search,
  hash: window.location.hash
});

export const useHomeRoute = () => {
  const [location, setLocation] = useState(readLocation);
  useEffect(() => {
    const onPopState = () => setLocation(readLocation());
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  switch (matchHomePath(location.pathname)) {
    case homePath:
      return homeRoute;
    case homeAliasPath:
      return homeAliasRoute;
    default:
      return null;
  }
};
